var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.121,
    height: 35.121,
    viewBox: "0 0 35.121 35.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "web",
    d: "M19.394,36.954A17.56,17.56,0,1,1,36.954,19.394,17.56,17.56,0,0,1,19.394,36.954Zm-4.021-4.1A31.433,31.433,0,0,1,12.417,21.15H5.454a14.063,14.063,0,0,0,9.918,11.708Zm.562-11.708a27.948,27.948,0,0,0,3.459,11.857,27.932,27.932,0,0,0,3.46-11.857Zm17.4,0H26.37a31.429,31.429,0,0,1-2.955,11.708A14.063,14.063,0,0,0,33.333,21.15ZM5.454,17.638h6.963A31.433,31.433,0,0,1,15.372,5.93,14.062,14.062,0,0,0,5.454,17.638Zm10.482,0h6.915A27.928,27.928,0,0,0,19.394,5.781a27.93,27.93,0,0,0-3.459,11.857ZM23.415,5.93A31.43,31.43,0,0,1,26.37,17.638h6.963A14.063,14.063,0,0,0,23.415,5.93Z",
    transform: "translate(-1.833 -1.833)",
    fill: "#ff6624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.b0a199e0f888325d8f423ec1af5bdb2f.svg";
export { ForwardRef as ReactComponent };